/* @flow */
import React, {Fragment} from 'react';
import gql from 'graphql-tag';
import {FormattedMessage} from 'react-intl';

import './HitSuperlative.less';

const MESSAGE_ID = {
    EXCEPTIONAL: 'superlativeExceptional',
    WONDERFUL: 'superlativeWonderful',
    EXCELLENT: 'superlativeExcellent',
    VERY_GOOD: 'superlativeVeryGood',
    GOOD: 'superlativeGood'
};

export const fragments = {
    SERPHit: gql`
        fragment HitSuperlativeSERPHit on SERPHit {
            superlative {
                rating
                value
            }
        }
    `
};

type SuperlativeValue = $Keys<typeof MESSAGE_ID>;
export type Shape = {
    value: SuperlativeValue,
    rating: number
};

type Props = Shape;

const HitSuperlative = ({rating, value}: Props) => (
    <FormattedMessage
        id={MESSAGE_ID[value]}
        description="superlative corresponding to a rating"
        defaultMessage={value}
    >
        {(txt) => (
            <Fragment>
                <strong>{txt}</strong> <span>{`${rating}/5`}</span>
            </Fragment>
        )}
    </FormattedMessage>
);

export default HitSuperlative;
